module.exports = "/_next/static/images/36d401733c48bd5ee834900467171c7d-phone-with-app-open-and-card@2x-xs.jpg.webp";